import React from 'react';
import { CreateSigningAppointmentFormData } from '../../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { Show } from '../../../../../../shared/Show';
import { eSigningMethod } from '../../../../../../../types/signingAppointment/eSigningMethod';
import { NumberField } from '../../../../../../../ui-toolkit';

export const RateField: React.FC<{ wizardFormData: CreateSigningAppointmentFormData }> = ({ wizardFormData }) => (
  <Show when={wizardFormData.signingMethod !== eSigningMethod.thirdPartyNotary}>
    <div className="mt-4 w-1/4">
      <NumberField name="rateCents" label="Rate" placeholder="95.00" valueIsCents mode="currency" />
    </div>
  </Show>
);
